import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppInitService } from 'src/app/app-init.service';
import { AppConfigurations, SyncFeature } from '../models/appConfiguration.model';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class SyncService {

  private appConfig!: AppConfigurations;
  private baseUrl: string = '';
  private syncFeatureConfig: SyncFeature = {
    enabledClients: [],
    forceDisable: ''
  };
  private syncController: string = "/api/sync";

  constructor(private http: HttpClient,
    private appInitService: AppInitService,
    private toastService: ToastService) {
    appInitService.getAppConfiguration$().subscribe({
      next: (config) => this._onReceiveAppConfig(config)
    })
  }

  private _onReceiveAppConfig(appConfig: AppConfigurations) {
    this.appConfig = appConfig;
    this.baseUrl = this.appConfig.adminApi.baseApiUrl;
    this.syncFeatureConfig = this.appConfig.syncFeature;
  }

  public getResourceName(resource: string) {
    switch (resource) {
      case "holidays":
        return "Holidays";
      case "locationhoursofoperation":
        return "Location Hours Of Operation";
      case "locations":
        return "Locations";
      case "servicecategories":
        return "Product Categories";
      case "services":
        return "Services";
      case "skills":
        return "Skills";
      case "useravailability":
        return "User Availability";
      case "users":
        return "Users";
      default:
        break;
    }
    throw new Error("Unexpected code path reached!");
  }

  public getSyncFeatureConfig(): SyncFeature {
    return this.syncFeatureConfig;
  }

  public sync(): Observable<any> {
    return this.http.post(`${this.baseUrl}${this.syncController}/all`, null);
  }

  public syncStarted() {
    this.toastService.showSuccess('_Shared_App_Sync_Initiate_Text_');
  }

  public syncCompleted() {
    this.toastService.showSuccess('_Shared_App_Sync_Initiate_Success_Text_');
  }

  public syncCompletedWithErrors() {
    this.toastService.showError('_Shared_App_Sync_Data_Error_Text_');
  }

  public syncInProgress() {
    this.toastService.showInfo('_Shared_App_State_Sync_InProcess_Text_');
  }

  public syncFailedToStart() {
    this.toastService.showError('_Shared_App_Sync_Data_Fail_Text_');
  }

  public syncFailedFromBackend(message: string) {
    this.toastService.showError(message);
  }

  public syncPartialFailure(message: string) {
    this.toastService.showError(message);
  }
}
